import { useCallback, useRef } from 'react'

interface SetFocusOptions {
    scrollIntoViewOptions?: ScrollIntoViewOptions
    focusOptions?: FocusOptions
}

export const useFocus = <T extends HTMLElement>() => {
    const ref = useRef<T | null>(null)
    const setFocus = useCallback((options?: SetFocusOptions) => {
        if (!ref.current) return
        try {
            ref.current.scrollIntoView(options?.scrollIntoViewOptions)
        } catch (e) {
            // ignore scroll errors
        }
        ref.current.focus(options?.focusOptions)
    }, [])
    return [ref, setFocus] as const
}
